import React, { FC } from 'react';
import moment from 'moment-timezone';

import { ICreateAbsenceRequestDTO } from 'src/api/dtos';
import { DATE_FORMAT, DATE_TIME_FORMAT } from 'src/shared/constants';
import { formatTime, isSameDay } from 'src/shared/utils';

interface Props {
  absenceRequest: Partial<ICreateAbsenceRequestDTO>;
  timeFormat: string | undefined;
}

export const AbsenceDateRange: FC<Props> = ({ absenceRequest, timeFormat }) => {
  const startDate = moment(absenceRequest.startDate).format(DATE_FORMAT);

  if (absenceRequest.startTime && absenceRequest.endTime) {
    const startTime = formatTime(absenceRequest.startTime, timeFormat, DATE_TIME_FORMAT);
    const endTime = formatTime(absenceRequest.endTime, timeFormat, DATE_TIME_FORMAT);

    return (
      <div className="ms-1 d-flex align-items-center">
        {startDate}
        <span className="ms-2 text-muted">
          {startTime} - {endTime}
        </span>
      </div>
    );
  }

  if (
    absenceRequest.startDate &&
    absenceRequest.endDate &&
    !isSameDay(absenceRequest.startDate, absenceRequest.endDate)
  ) {
    const endDate = moment(absenceRequest.endDate).format(DATE_FORMAT);

    return (
      <div className="ms-1">
        {startDate} - {endDate}
      </div>
    );
  }

  return <div className="ms-1">{startDate}</div>;
};
